module.exports = __webpack_public_path__ + "static/media/map-pin-red.3673f9f3.svg";